import { FunctionalComponent} from 'preact';

import { getTranslation } from '../../../../../../shared/chromeApi';

import facebookIcon from './assets/facebook.png';
import pinterestIcon from './assets/pinterest.png';
import twitterIcon from './assets/twitter.png';

import styles from './../styles.module.scss';

const CounterPopver: FunctionalComponent = () => (
  <div className={styles.popover}>
    <div className={styles.outerPopover}>
      <div className={styles.innerPopover}>
        <p className={styles.description}>
          {getTranslation('new_tab_counter_description_lite')}
        </p>
        <footer className={styles.footer}>
          <div>
            <a
              className={styles.link}
              href="https://about.oceanhero.today/how-it-works"
            >
              {getTranslation('new_tab_counter_read')}
            </a>
            <a
              className={styles.link}
              href="https://about.oceanhero.today/certificates"
            >
              {getTranslation('new_tab_counter_certificates')}
            </a>
          </div>
          <div>
            <a
              href="https://facebook.com/sharer/sharer.php?u=https%3A%2F%2Foceanhero.today%2F"
              target="_blank"
              rel="noreferrer noopener"
              aria-label="Share on Facebook"
            >
              <img
                src={facebookIcon}
                width="16"
                height="16"
                alt="Facebook share"
              />
            </a>
            <a
              href="https://twitter.com/intent/tweet/?text=By%20searching%20with%20OceanHero%2C%20you%20can%20help%20us%20cleaning%20up%20the%20oceans%20from%20more%20than%205%20trillion%20pieces%20of%20plastic.&amp;url=https%3A%2F%2Foceanhero.today%2F"
              target="_blank"
              rel="noreferrer noopener"
              aria-label="Share on Twitter"
            >
              <img
                src={twitterIcon}
                width="16"
                height="16"
                alt="Twitter share"
              />
            </a>
            <a
              href="https://pinterest.com/pin/create/button/?url=https%3A%2F%2Foceanhero.today%2F&amp;media=https%3A%2F%2Foceanhero.today%2F&amp;description=By%20searching%20with%20OceanHero%2C%20you%20can%20help%20us%20cleaning%20up%20the%20oceans%20from%20more%20than%205%20trillion%20pieces%20of%20plastic."
              target="_blank"
              rel="noreferrer noopener"
              aria-label="Share on Pinterest"
            >
              <img
                src={pinterestIcon}
                width="16"
                height="16"
                alt="Pinterest share"
              />
            </a>
          </div>
        </footer>
      </div>
    </div>
  </div>
);

export default CounterPopver;
